(function () {
  'use strict';
  if (customElements.get('zt-product-information')) return;

  class ProductInformation extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced) return;
      const fallback = this.querySelector('[data-zt-information-fallback]');
      const source = this.querySelector('[data-zt-information-content]');
      if (!fallback || !source) return;
      const nodes = Array.from(source.childNodes);
      const groups = [{ type: 'benefits', nodes: [] }];
      const headings = [
        ['ingredients', /^ingredients\b/i],
        ['directions', /^(?:usage\s+instructions|directions(?:\s+for\s+use)?|instructions(?:\s+for\s+use)?|how\s+to\s+use)\b/i],
        ['documents', /^(?:sizes?\s+available|dilution|mixing\s+instructions|documents|safety\s+data\s+sheets?)\b/i],
        ['safety', /^(?:safety|safe\s+use|warnings?)\b/i],
        ['faq', /^(?:faqs?|frequently\s+asked\s+questions)\b/i],
      ];
      const meaningful = node => node.nodeType === 1 || (node.nodeType === 3 && node.textContent.trim());
      nodes.forEach(node => {
        let group = groups[groups.length - 1];
        if (node.nodeType === 1 && /^(?:P|DIV|H[1-6])$/.test(node.tagName)) {
          const text = node.textContent.replace(/\s+/g, ' ').trim();
          const match = headings.find(([, pattern]) => pattern.test(text));
          if (match) {
            if (group.nodes.some(meaningful)) {
              group = { type: match[0], nodes: [] };
              groups.push(group);
            } else group.type = match[0];
          }
        }
        group.nodes.push(node);
      });
      // Unrecognized/nested HTML stays in the complete native fallback.
      if (groups.length < 2 || groups.reduce((count, group) => count + group.nodes.length, 0) !== nodes.length) return;
      if (groups.some(group => !this.dataset[group.type + 'Label'])) return;
      const fragment = document.createDocumentFragment();
      groups.forEach(group => {
        const details = document.createElement('details');
        const summary = document.createElement('summary');
        summary.textContent = this.dataset[group.type + 'Label'];
        const body = document.createElement('div');
        // Move every original node once; never rebuild, truncate or discard copy.
        group.nodes.forEach(node => body.appendChild(node));
        details.append(summary, body);
        fragment.appendChild(details);
      });
      fallback.replaceWith(fragment);
      this.dataset.enhanced = 'true';
    }
  }
  customElements.define('zt-product-information', ProductInformation);
}());
